import React from 'react';
//import {Link} from 'react-router-dom';
//import {Button} from "./Button";
import Title from "./Title";
//import createLink from "../../libs/createLink";

const HeaderCtaAds = (props) => {
    return (
        <div id="signin-klingon-container" className="container">
            <div className="signin-klingon-wrapper">
                <div className="signin">
                    <Title heading={"heading-2"} >
                        Voissa : Révélez-vous
                    </Title>
                    <Title heading={"heading-3"}>
                        Le plus bel espace de liberté
                    </Title>

                </div>
            </div>
        </div>
    )
};
export default HeaderCtaAds;
